import Page from 'flarum/common/components/Page';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import app from 'flarum/app';
import classList from 'flarum/common/utils/classList';
import sortTags from 'flarum/tags/common/utils/sortTags';

export default class PagePage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    this.tags = [];
    this.tagItem = [];
    this.localeMainImgUrl = '';
    app.tagList.load(['children', 'lastPostedDiscussion', 'parent', 'wikiLabel', 'wikiLabel.wikiLabelOptions', 'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon', 'wikiHeroDetailDiscussion', 'heroTagLatestdata' ,'heroTagLatestdata.heroTagHeroIntro' ,'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel']).then(() => {
      this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));

      this.loading = false;
      m.redraw();
    });
  }

  navItems(vnode) {
    const items = new ItemList();
    const params = app.search.stickyParams();
    // this.activeButton = localStorage.getItem('activeButton') || 'allDiscussions';
    items.add(
      'allDiscussions',
      <LinkButton href={app.route('pages.home', params)} onclick={(e) => {
        const active = document.getElementsByClassName('item-allDiscussions')[0].classList.value.indexOf('active');
        if (active !== -1) {
          e.preventDefault();
          return false;
        }
      }}>
        <span className={classList(["navItem",
          vnode.attrs.routeName == 'pages.home' ? 'underline-yellow' : ''
        ])}>{app.translator.trans('dl-index.forum.indexPage')}</span>
      </LinkButton>,
      100
    );

    items.add(
      'plate',
      <LinkButton href={app.route('tags')} onclick={(e) => {
        const active = document.getElementsByClassName('item-plate')[0].classList.value.indexOf('active');
        if (active !== -1) {
          e.preventDefault();
          return false;
        }
      }}>
        <span className={classList(["navItem plate",
          vnode.attrs.routeName == 'tags' ? 'underline-yellow' : ''
        ])}>{app.translator.trans('dl_tag.forum.title')}</span>
      </LinkButton>,
      70
    );
    
    let tagItem = sessionStorage.getItem('tagItem');
    let tagOne = app.store.getBy('tags', 'slug', tagItem);
    if (tagOne && tagOne.pkgId() == app.data.pkgLogo.id) {
      let tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));
      const pinned = tags.filter((tag) => tag.position() !== null && tag.slug() == tagItem && tag.pkgId() == app.data.pkgLogo.id);
      if (pinned && pinned.length > 0) {
        let name = pinned[0].name();
        // 将字符串映射转换为 JavaScript 对象
        const obj = JSON.parse(name);
        // 创建 Map 对象并初始化
        const map = new Map(Object.entries(obj));
        // 获取特定键的值
        let localeName = map.get(app.data.locale);
        items.add(
          'tagItem',
          <LinkButton href={app.route('tag', {tags: tagItem})} onclick={(e) => {
            const active = document.getElementsByClassName('item-tagItem')[0].classList.value.indexOf('active');
            if (active !== -1) {
              e.preventDefault();
              return false;
            }
          }}>
            <span className={classList(["navItem plate",
              vnode.attrs.routeName == 'tag' ? 'underline-yellow' : ''
            ])}>{localeName}</span>
          </LinkButton>,
          70
        );
      }
    }
    return items;
  }

  view() {
    return (
      <div>
        {this.headerTabs()}
        {/* <div className="Pages-page">
        </div> */}
      </div>
    );
  }

  //页面tab选项
  headerTabs(vnode) {
    return (
      <div className="sideNavContainer">
        <nav className="IndexPage-nav sideNav navItems navItems-lin">
          <ul id='navItems-ul'>{listItems(this.navItems(vnode).toArray())}</ul>
        </nav>
      </div>
    );
  }

 

  //按钮选项
  centerTabs() {
    return (
      <div className="sideNavContainer  dl-container">
        <nav className="IndexPage-nav sideNav sideNav-lin">
          <ul>{listItems(this.centerNavItems())}</ul>
        </nav>
      </div>
    );
  }
  // homeTagsClick(item, attrs) {
  //   if (item == 'allDiscussions') {
  //     this.checked = true;
  //     attrs.onDataFromChild(true);
  //   } else {
  //     this.checked = false;
  //     attrs.onDataFromChild(false);
  //   }
  // }
}
